import React, { useEffect, useState } from "react";
import { Row, Col, Input, Button, Select, Divider, Typography } from "../../ui/ot";
import { Form } from "antd";
import dayjs from "dayjs";
const { TextArea } = Input;

const CommunityForm = ({
    propsForm = null,
    formReloadCount = 0,
    selectOption = [],
    onFormFinish = () => { },
}) => {
    const [form] = Form.useForm();
    const [files, setFiles] = useState([]);

    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: formValues?.comments * formValues?.number || 0,
        };
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues);
        } else {
            form.setFieldsValue(newFormValues);
        }
    };

    const onChangeFileValue = (values) => {
        let file = values?.file ?? [];
        setFiles(file);
    };
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        // getNewsTypeOption()
        // getNewsWeightTypeOption()
    };
    const onFinish = (values) => {
        let news_time = dayjs(values?.news_time).format("YYYY-MM-DD HH:mm:ss");
        let announce_time_end = dayjs(values?.announce_time_end).format(
            "YYYY-MM-DD HH:mm:ss"
        );
        onFormFinish({
            ...values,
            news_time,
            announce_time_end,
        });
        form.resetFields();
    };
    
    const onValuesChange = () => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
        setFormValuesOtherThings(formValues);
    };

    useEffect(() => {
        setDataInitialization();
    }, []);
    useEffect(() => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
        // setFormValuesOtherThings(formValues)
        onChangeFileValue(formValues);
    }, [formReloadCount]);

    return (
        <Row gutter={[10, 20]} justify="space-around" style={{ padding: "3vmin" }}>
            <Col span={24}>
                <Form
                    layout="vertical"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]} style={{ justifyContent: "end" }}>
                        {/* <Col>
                            <Button htmlType="button" size="large">
                                清除
                            </Button>
                        </Col> */}
                        <Col>
                            <Button type="primary" htmlType="submit">
                                儲存
                            </Button>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                    <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                            <Row justify={"center"} gutter={[20, 20]}>
                                <Col>
                                    <Form.Item
                                        hidden={true}
                                        name={"information_id"}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col lg={24} md={24} sm={24} xs={24}>
                                    <Form.Item
                                        label={"Google Map iframe"}
                                        name={"google_map_iframe"}
                                    >
                                        <TextArea rows={6} allowClear />
                                    </Form.Item>
                                </Col>

                                <Col lg={24} md={24} sm={24} xs={24}>
                                    <Form.Item label={"Google Map 預覽"}>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: (
                                                    Form.useWatch("google_map_iframe", propsForm) || ""
                                                ).replace(
                                                    `width="600" height="450"`,
                                                    `width="100%" height="100%"`
                                                ),
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>

                        <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                            <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Typography.Title
                                        level={4}
                                    >
                                        網站社群設定
                                    </Typography.Title>
                                </Col>
                                <Col span={24}>
                                    <Divider></Divider>
                                </Col>
                                <Col span={24}>
                                    <Form.List name="information_community_data">
                                        {(fields, { add, remove }) => (
                                            <>
                                                {fields.map(({ key, name, ...restField }) => (
                                                    <Row gutter={[8, 8]} key={key}>
                                                        <Col>
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, "information_community_id"]}
                                                                hidden
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={8}>

                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, "community_id"]}
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "請勿空白",
                                                                    },
                                                                ]}
                                                            >
                                                                <Select
                                                                    style={{ width: 200 }}
                                                                    options={
                                                                        selectOption &&
                                                                        selectOption.map(
                                                                            (selectOptionItem, selectOptionIndex) => {
                                                                                return {
                                                                                    ...selectOptionItem,
                                                                                    value: selectOptionItem.community_id,
                                                                                    label: selectOptionItem.name,
                                                                                };
                                                                            }
                                                                        )
                                                                    }
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col>
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, "link"]}
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "請勿空白",
                                                                    },
                                                                ]}
                                                            >
                                                                <Input placeholder="網址" />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col>
                                                            <Button onClick={() => remove(name)}>刪除</Button>
                                                        </Col>
                                                    </Row>
                                                ))}
                                                <Form.Item>
                                                    <Button
                                                        type="dashed"
                                                        onClick={() => add()}
                                                        block
                                                    >
                                                        新增社群
                                                    </Button>
                                                </Form.Item>
                                            </>
                                        )}
                                    </Form.List>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    );
};

export default CommunityForm;
